$(document).foundation();

var $window = $(window);
var $header = $('header');
var $firstSection = $('section:first-of-type');

document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.offsetWidth) + 'px');

jQuery(document).ready(function($) {

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  });

  // styling pests because of shortcode with content
  $('p:empty').remove();

  // navigation
  var navSubitemsTimer = null;
  $('.page-nav.has-subitems > a')
    .on("mouseenter", function(e) {
      clearTimeout(navSubitemsTimer);
      e.preventDefault();
      var $target = $(e.target).closest('a');
      $target.siblings('.subitems-container').removeClass('hide');
    })
    .on("mouseleave", function(e) {
      navSubitemsTimer = setTimeout(function() {
        e.preventDefault();
        var $target = $(e.target).closest('a');
        $target.siblings('.subitems-container').addClass('hide');  
      },100);
    });
  $('.subitems-container')
  .on("mouseenter", function(e) {
    clearTimeout(navSubitemsTimer);
    e.preventDefault();
    var $target = $(e.target).closest('.subitems-container');
    $target.removeClass('hide');
  })
  .on("mouseleave", function(e) {
    navSubitemsTimer = setTimeout(function() {
      e.preventDefault();
      var $target = $(e.target).closest('.subitems-container');
      $target.addClass('hide');  
    },100);
  });

  navHandler.init();
  staggerHandler.init();
  byTheNumbersHandler.init();

  $('.quotes-carousel').flickity({
    wrapAround: true,
    pageDots: true,
    fullscreen: false,
    prevNextButtons: false,
    autoPlay: false,
    imagesLoaded: true,
  });

  $('.bod-carousel').flickity({
    cellAlign: 'left',
    prevNextButtons: true,
    wrapAround: false,
    pageDots: false,
    fullscreen: false,
    autoPlay: false,
    imagesLoaded: true,
    groupCells: '100%',
  });

  $window.on('resize', function() {
    // resize videos
    // $('.responsive-embed.widescreen').each(function() {
    //   // widescreen is 16:9

    // });
    // debugger
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})
